var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render"})
}
var staticRenderFns = []

export { render, staticRenderFns }